import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_LIST,
  ACTION_UPDATE,
} from "../../../models/role/action";
import { SUBJECT_BANK } from "../../../models/role/subject";
import { lazyRetry } from "../../../utils/lazyRetry";

import type { Route } from "../../../routes/RouteModel";

const BankList = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "BankAdministration" */
      "../pages/List"
    ),
  "BankAdministration"
);
const BankDetails = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "BankAdministration" */
      "../pages/Details"
    ),
  "BankAdministration"
);
const BankEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "BankAdministration" */
      "../pages/Edit"
    ),
  "BankAdministration"
);
const BankCreate = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "BankAdministration" */
      "../pages/Create"
    ),
  "BankAdministration"
);

export const bankRoutes: Route = {
  i18nName: "Banks",
  path: "/administration/banks",
  component: BankList,
  showChildrenInSidebar: false,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_BANK,
  },
  children: [
    {
      path: "/administration/banks/create",
      i18nName: "Create bank",
      component: BankCreate,
      can: {
        do: ACTION_CREATE,
        on: SUBJECT_BANK,
      },
    },
    {
      path: "/administration/banks/:id/edit",
      i18nName: "Edit bank",
      component: BankEdit,
      can: {
        do: ACTION_UPDATE,
        on: SUBJECT_BANK,
      },
    },
    {
      path: "/administration/banks/:id",
      i18nName: "Bank",
      component: BankDetails,
      can: {
        do: ACTION_DETAILS,
        on: SUBJECT_BANK,
      },
    },
  ],
};
